var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 16,
  fill: "inherit",
  viewBox: "0 0 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.433 2.88H.481v1.428l-.012.015 8.468 7.162.032.04.007-.007.006.005.025-.03 7.046-5.954v8.896H3.313v1.444h14.156v-13h-.036Zm-2.162 1.444L8.977 9.643l-6.289-5.32h12.583Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M.469 6.13v9.75h1.416V7.331L.47 6.129Z"
})));
export default SvgMail;